/**
 * @generated SignedSource<<6bcd30cbaeb5048edaf71f41da88c5e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PublishLegalDocumentInput = {
  documentType: string;
  effectiveFrom: any;
  locale: string;
  organizationId?: string | null | undefined;
  storageUri?: string | null | undefined;
  systemId?: string | null | undefined;
  textContent: string;
  version: string;
};
export type useLegalDocumentMutationsPublishMutation$variables = {
  input: PublishLegalDocumentInput;
};
export type useLegalDocumentMutationsPublishMutation$data = {
  readonly publishLegalDocument: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
    }>;
    readonly result: {
      readonly documentType: string;
      readonly effectiveFrom: any;
      readonly id: string;
      readonly locale: string;
      readonly organizationId: string | null | undefined;
      readonly systemId: string | null | undefined;
      readonly textContent: string;
      readonly version: string;
    } | null | undefined;
  };
};
export type useLegalDocumentMutationsPublishMutation = {
  response: useLegalDocumentMutationsPublishMutation$data;
  variables: useLegalDocumentMutationsPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublishLegalDocumentResult",
    "kind": "LinkedField",
    "name": "publishLegalDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalDocument",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectiveFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textContent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLegalDocumentMutationsPublishMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLegalDocumentMutationsPublishMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "30fb8ff5dea9726c84a1afddf189e6dd",
    "id": null,
    "metadata": {},
    "name": "useLegalDocumentMutationsPublishMutation",
    "operationKind": "mutation",
    "text": "mutation useLegalDocumentMutationsPublishMutation(\n  $input: PublishLegalDocumentInput!\n) {\n  publishLegalDocument(input: $input) {\n    errors {\n      code\n      fields\n      message\n      shortMessage\n    }\n    result {\n      id\n      documentType\n      locale\n      version\n      systemId\n      organizationId\n      effectiveFrom\n      textContent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0cd89823a175fd4b2e0cc24c33d7b0f";

export default node;
